import { ReactNode } from "react";

import Filters from "components/Filters";
import FiltersSplit from "components/Filters/Split";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import {
  INITIAL_SORT_OPTION,
  INITIAL_SORT_DIRECTION,
  FILTER_TYPE,
  INTENT_PROJECTS_SUGGESTIONS_DICTIONARY,
} from "shared/IntentProject/useSearchIntentProjectsSuggestions/constants";
import useSearchIntentProjectsSuggestions from "shared/IntentProject/useSearchIntentProjectsSuggestions";

import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";

type IntentProjectsFiltersLayoutProps = {
  children: ReactNode;
};

const IntentProjectsFiltersLayout = ({ children }: IntentProjectsFiltersLayoutProps) => {
  const { filters, filterOptionsMap, loading } = useSearchIntentProjectsSuggestions();

  return (
    <Filters
      filters={filters}
      filtersItemsOptionsMap={filterOptionsMap}
      filtersLoading={loading}
      sortOptions={[]}
      initialSortOption={INITIAL_SORT_OPTION}
      initialSortDirection={INITIAL_SORT_DIRECTION}
      filtersType={FILTER_TYPE}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersDictionary={INTENT_PROJECTS_SUGGESTIONS_DICTIONARY}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default IntentProjectsFiltersLayout;
